/**
 * Detect whether a URL query string opts into site debug mode via
 * `?debug=linkparams`.
 *
 * History: the opt-in used to be `?debug=1`, checked with
 * `location.search.indexOf('debug=1') > -1`. That naked substring match
 * returned true for any param whose value *contained* the substring
 * `debug=1` — most notably Google Tag Manager's preview id, e.g.
 * `?gtm_debug=1787853714925`, which GTM appends to every navigation while
 * Preview mode is active. The false positive silently enabled debug mode,
 * which in turn had the pre-hydration click handler in `gatsby-ssr.js` call
 * `event.preventDefault()` on every `<a>` click and block all site
 * navigation. This helper replaces that check and simultaneously renames
 * the opt-in value to `linkparams` so the flag name describes what debug
 * mode actually does (preventDefault + log cross-domain-param rewrites on
 * link clicks) and so the historical `?debug=1` URL is no longer a live
 * opt-in surface.
 *
 * Callers should pass `window.location.search` (or an equivalent string) as
 * the sole argument. The function is safe to call with `null`, `undefined`,
 * an empty string, or a value with or without a leading `?`.
 *
 * NOTE: The inline pre-hydration script in `gatsby-ssr.js` cannot import from
 * this module — it runs before the JS bundle loads. It uses an equivalent
 * regex inline. See the test file for the regex-parity check that keeps the
 * two implementations in sync.
 */
export const hasDebugFlag = (search) => {
  if (typeof search !== 'string' || search.length === 0) {
    return false;
  }
  try {
    const normalized = search.charAt(0) === '?' ? search.slice(1) : search;
    return new URLSearchParams(normalized).get('debug') === 'linkparams';
  } catch (e) {
    return false;
  }
};

export default hasDebugFlag;
